export default __webpack_public_path__ + "static/media/Ideas.107c4ec0.svg";